var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo 2096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1792"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1769"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2744",
    d: "M35.4561 26.2456H30.567C30.2722 26.2456 30.0339 26.0073 30.0339 25.7125C30.0339 25.4182 30.2722 25.1793 30.567 25.1793H34.3898V23.8587L31.0607 12.76H4.66322L1.31179 23.9333C1.22702 24.2159 0.929538 24.3759 0.648007 24.2911C0.365453 24.2063 0.205498 23.9094 0.29029 23.6273L3.86987 11.6937H31.8541L35.4561 23.7803V26.2456Z",
    fill: "#CCBD99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1780"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1770"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2745",
    d: "M7.92229 12.76C7.628 12.76 7.38916 12.5212 7.38916 12.2269V10.556C7.38916 10.2617 7.628 10.0228 7.92229 10.0228C8.2166 10.0228 8.45546 10.2617 8.45546 10.556V12.2269C8.45546 12.5212 8.2166 12.76 7.92229 12.76Z",
    fill: "#CCBD99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1771"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2746",
    d: "M14.3419 12.7601C14.0477 12.7601 13.8088 12.5213 13.8088 12.227V9.68543C13.8088 8.53488 12.8726 7.59866 11.7226 7.59866H8.88943C7.73831 7.59866 6.80265 8.53488 6.80265 9.68543V12.227C6.80265 12.5213 6.56381 12.7601 6.2695 12.7601C5.97466 12.7601 5.73633 12.5213 5.73633 12.227V9.68543C5.73633 7.94681 7.15026 6.53235 8.88943 6.53235H11.7226C13.4607 6.53235 14.8751 7.94681 14.8751 9.68543V12.227C14.8751 12.5213 14.6363 12.7601 14.3419 12.7601Z",
    fill: "#CCBD99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2747",
    d: "M12.6892 12.76C12.3948 12.76 12.156 12.5212 12.156 12.2269V10.556C12.156 10.2617 12.3948 10.0228 12.6892 10.0228C12.9835 10.0228 13.2223 10.2617 13.2223 10.556V12.2269C13.2223 12.5212 12.9835 12.76 12.6892 12.76Z",
    fill: "#CCBD99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1773"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2748",
    d: "M10.3055 6.33501C8.67189 6.33501 7.34326 5.00586 7.34326 3.37228C7.34326 1.7387 8.67189 0.409546 10.3055 0.409546C11.9391 0.409546 13.2682 1.7387 13.2682 3.37228C13.2682 5.00586 11.9391 6.33501 10.3055 6.33501ZM10.3055 1.47585C9.25996 1.47585 8.40958 2.32677 8.40958 3.37228C8.40958 4.41779 9.25996 5.26871 10.3055 5.26871C11.3515 5.26871 12.2019 4.41779 12.2019 3.37228C12.2019 2.32677 11.3515 1.47585 10.3055 1.47585Z",
    fill: "#CCBD99"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2749",
    d: "M23.0349 12.76C22.74 12.76 22.5017 12.5212 22.5017 12.2269V10.556C22.5017 10.2617 22.74 10.0228 23.0349 10.0228C23.3297 10.0228 23.568 10.2617 23.568 10.556V12.2269C23.568 12.5212 23.3297 12.76 23.0349 12.76Z",
    fill: "#CCBD99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2750",
    d: "M29.4546 12.7601C29.1597 12.7601 28.9214 12.5213 28.9214 12.227V9.68543C28.9214 8.53488 27.9852 7.59866 26.8346 7.59866H24.0015C22.8509 7.59866 21.9147 8.53488 21.9147 9.68543V12.227C21.9147 12.5213 21.6764 12.7601 21.3815 12.7601C21.0872 12.7601 20.8484 12.5213 20.8484 12.227V9.68543C20.8484 7.94681 22.2634 6.53235 24.0015 6.53235H26.8346C28.5733 6.53235 29.9877 7.94681 29.9877 9.68543V12.227C29.9877 12.5213 29.7494 12.7601 29.4546 12.7601Z",
    fill: "#CCBD99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1777"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2751",
    d: "M27.8012 12.76C27.5069 12.76 27.2681 12.5212 27.2681 12.2269V10.556C27.2681 10.2617 27.5069 10.0228 27.8012 10.0228C28.096 10.0228 28.3344 10.2617 28.3344 10.556V12.2269C28.3344 12.5212 28.096 12.76 27.8012 12.76Z",
    fill: "#CCBD99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2752",
    d: "M25.4181 6.33501C23.7845 6.33501 22.4553 5.00586 22.4553 3.37228C22.4553 1.7387 23.7845 0.409546 25.4181 0.409546C27.0516 0.409546 28.3808 1.7387 28.3808 3.37228C28.3808 5.00586 27.0516 6.33501 25.4181 6.33501ZM25.4181 1.47585C24.3725 1.47585 23.5216 2.32677 23.5216 3.37228C23.5216 4.41779 24.3725 5.26871 25.4181 5.26871C26.4636 5.26871 27.3145 4.41779 27.3145 3.37228C27.3145 2.32677 26.4636 1.47585 25.4181 1.47585Z",
    fill: "#CCBD99"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1783"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1781"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2753",
    d: "M13.922 31.3175H13.8628C13.0524 31.3175 12.3934 30.6585 12.3934 29.8481V26.8433C12.3934 26.5489 12.6323 26.3101 12.9266 26.3101C13.2214 26.3101 13.4597 26.5489 13.4597 26.8433V29.8481C13.4597 30.0704 13.6405 30.2512 13.8628 30.2512H13.922C14.1438 30.2512 14.3245 30.0704 14.3245 29.8481V23.7893C14.3245 22.3472 13.1516 21.1742 11.7094 21.1742H8.30469C6.86305 21.1742 5.69008 22.3472 5.69008 23.7893V29.8481C5.69008 30.0704 5.8703 30.2512 6.09261 30.2512C6.31495 30.2512 6.49568 30.0704 6.49568 29.8481V26.8433C6.49568 26.5489 6.73454 26.3101 7.02883 26.3101C7.32312 26.3101 7.56196 26.5489 7.56196 26.8433V29.8481C7.56196 30.6585 6.903 31.3175 6.09261 31.3175C5.28274 31.3175 4.62378 30.6585 4.62378 29.8481V23.7893C4.62378 21.7591 6.27496 20.1079 8.30469 20.1079H11.7094C13.7391 20.1079 15.3908 21.7591 15.3908 23.7893V29.8481C15.3908 30.6585 14.7318 31.3175 13.922 31.3175Z",
    fill: "#CCBD99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1782"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2754",
    d: "M10.0072 19.6558C8.10327 19.6558 6.55444 18.1064 6.55444 16.2031C6.55444 14.2992 8.10327 12.7504 10.0072 12.7504C11.9111 12.7504 13.4599 14.2992 13.4599 16.2031C13.4599 18.1064 11.9111 19.6558 10.0072 19.6558ZM10.0072 13.8167C8.69134 13.8167 7.62074 14.8872 7.62074 16.2031C7.62074 17.5189 8.69134 18.5895 10.0072 18.5895C11.3236 18.5895 12.3936 17.5189 12.3936 16.2031C12.3936 14.8872 11.3236 13.8167 10.0072 13.8167Z",
    fill: "#CCBD99"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2755",
    d: "M13.4597 34.082H6.49561V25.849C6.49561 24.5721 7.53422 23.5341 8.81057 23.5341H11.2034C11.8341 23.5341 12.4398 23.7932 12.8657 24.2458C13.2848 24.6905 13.4954 25.2711 13.4586 25.8805L13.4597 34.082ZM7.56195 33.0157H12.3934V25.849C12.4131 25.5035 12.3049 25.2055 12.09 24.9768C11.8645 24.7374 11.5414 24.6004 11.2034 24.6004H8.81057C8.12227 24.6004 7.56195 25.1602 7.56195 25.849V33.0157Z",
    fill: "#CCBD99"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2756",
    d: "M29.631 31.3175H29.5723C28.7619 31.3175 28.1029 30.6585 28.1029 29.8481V26.8433C28.1029 26.5489 28.3412 26.3101 28.6361 26.3101C28.9304 26.3101 29.1692 26.5489 29.1692 26.8433V29.8481C29.1692 30.0704 29.35 30.2512 29.5723 30.2512H29.631C29.8533 30.2512 30.034 30.0704 30.034 29.8481V23.7893C30.034 22.3472 28.8611 21.1742 27.4184 21.1742H24.0147C22.5725 21.1742 21.3991 22.3472 21.3991 23.7893V29.8481C21.3991 30.0704 21.5798 30.2512 21.8021 30.2512C22.0239 30.2512 22.2046 30.0704 22.2046 29.8481V26.8433C22.2046 26.5489 22.443 26.3101 22.7378 26.3101C23.0327 26.3101 23.2709 26.5489 23.2709 26.8433V29.8481C23.2709 30.6585 22.6125 31.3175 21.8021 31.3175C20.9922 31.3175 20.3328 30.6585 20.3328 29.8481V23.7893C20.3328 21.7591 21.9845 20.1079 24.0147 20.1079H27.4184C29.4486 20.1079 31.1003 21.7591 31.1003 23.7893V29.8481C31.1003 30.6585 30.4408 31.3175 29.631 31.3175Z",
    fill: "#CCBD99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1787"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2757",
    d: "M25.7166 19.6558C23.8132 19.6558 22.2644 18.1064 22.2644 16.2031C22.2644 14.2992 23.8132 12.7504 25.7166 12.7504C27.6199 12.7504 29.1693 14.2992 29.1693 16.2031C29.1693 18.1064 27.6199 19.6558 25.7166 19.6558ZM25.7166 13.8167C24.4008 13.8167 23.3307 14.8872 23.3307 16.2031C23.3307 17.5189 24.4008 18.5895 25.7166 18.5895C27.0324 18.5895 28.1029 17.5189 28.1029 16.2031C28.1029 14.8872 27.0324 13.8167 25.7166 13.8167Z",
    fill: "#CCBD99"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1789"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2758",
    d: "M29.1692 34.082H22.2046V25.849C22.2046 24.5721 23.2432 23.5341 24.5201 23.5341H26.9129C27.5436 23.5341 28.1498 23.7932 28.5758 24.2464C28.9948 24.691 29.2049 25.2716 29.1681 25.881L29.1692 34.082ZM23.2709 33.0157H28.1029V25.849C28.1226 25.5035 28.0149 25.2055 27.799 24.9773C27.574 24.7374 27.2509 24.6004 26.9129 24.6004H24.5201C23.8313 24.6004 23.2709 25.1602 23.2709 25.849V33.0157Z",
    fill: "#CCBD99"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1793"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2759",
    d: "M5.15687 26.2456H0.267822V23.7894C0.267822 23.4945 0.50615 23.2562 0.800992 23.2562C1.0953 23.2562 1.33414 23.4945 1.33414 23.7894V25.1793H5.15687C5.45116 25.1793 5.69002 25.4182 5.69002 25.7125C5.69002 26.0073 5.45116 26.2456 5.15687 26.2456Z",
    fill: "#CCBD99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1797"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2763",
    d: "M34.9229 24.3134H32.6128C32.3179 24.3134 32.0796 24.0745 32.0796 23.7802C32.0796 23.4859 32.3179 23.2471 32.6128 23.2471H34.9229C35.2172 23.2471 35.456 23.4859 35.456 23.7802C35.456 24.0745 35.2172 24.3134 34.9229 24.3134Z",
    fill: "#CCBD99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1794"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2760",
    d: "M20.8657 26.2456H14.8576C14.5633 26.2456 14.3245 26.0073 14.3245 25.7125C14.3245 25.4182 14.5633 25.1793 14.8576 25.1793H20.8657C21.1605 25.1793 21.3989 25.4182 21.3989 25.7125C21.3989 26.0073 21.1605 26.2456 20.8657 26.2456Z",
    fill: "#CCBD99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1795"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2761",
    d: "M5.15687 24.3134H0.800992C0.50615 24.3134 0.267822 24.0745 0.267822 23.7802C0.267822 23.4859 0.50615 23.2471 0.800992 23.2471H5.15687C5.45116 23.2471 5.69002 23.4859 5.69002 23.7802C5.69002 24.0745 5.45116 24.3134 5.15687 24.3134Z",
    fill: "#CCBD99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1796"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2762",
    d: "M18.5726 24.3225H14.8576C14.5633 24.3225 14.3245 24.0837 14.3245 23.7894C14.3245 23.4945 14.5633 23.2562 14.8576 23.2562H18.5726C18.8669 23.2562 19.1058 23.4945 19.1058 23.7894C19.1058 24.0837 18.8669 24.3225 18.5726 24.3225Z",
    fill: "#CCBD99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2764",
    d: "M3.04511 31.3175C2.75027 31.3175 2.51196 31.0787 2.51196 30.7844V25.7125C2.51196 25.4182 2.75027 25.1793 3.04511 25.1793C3.3394 25.1793 3.57826 25.4182 3.57826 25.7125V30.7844C3.57826 31.0787 3.3394 31.3175 3.04511 31.3175Z",
    fill: "#CCBD99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1799"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2765",
    d: "M32.6789 30.7545C32.3841 30.7545 32.1458 30.5157 32.1458 30.2214V25.7125C32.1458 25.4182 32.3841 25.1793 32.6789 25.1793C32.9732 25.1793 33.2121 25.4182 33.2121 25.7125V30.2214C33.2121 30.5157 32.9732 30.7545 32.6789 30.7545Z",
    fill: "#CCBD99"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/card2.8f9244e3438b1513f1b84547350e2e2d.svg";
export { ForwardRef as ReactComponent };